/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { publication_book_section_full } from './publication_book_section_full';
export type publication_book_full = {
  id: string;
  name: string;
  version_id: number;
  army_id: number;
  army_name: string;
  army_logo: string | null;
  executed_at: number | null;
  build_url: string | null;
  build_status: publication_book_full.build_status;
  updated_at: number;
  sections: Array<publication_book_section_full>;
};
export namespace publication_book_full {
  export enum build_status {
    NOTBUILT = 'notbuilt',
    BUILDING = 'building',
    BUILT = 'built',
    FAILED = 'failed',
  }
}
